var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-popup"},[_c('header',[_vm._v("Должен содержать:")]),_c('main',[_c('ul',[_c('li',[_c(_vm.passwordValidator.$model &&
            _vm.passwordValidator.minLength &&
            _vm.passwordValidator.$dirty
              ? 'OkRoundIcon'
              : 'ErrorRoundIcon',{tag:"component"}),_vm._v(" Минимум 8 символов; ")],1),_c('li',[_c(_vm.passwordValidator.$model &&
            _vm.passwordValidator.maxLength &&
            _vm.passwordValidator.$dirty
              ? 'OkRoundIcon'
              : 'ErrorRoundIcon',{tag:"component"}),_vm._v(" Максимум 64 символа; ")],1),_c('li',[_c(_vm.passwordValidator.uppercase && _vm.passwordValidator.$dirty
              ? 'OkRoundIcon'
              : 'ErrorRoundIcon',{tag:"component"}),_vm._v(" Заглавные буквы латинского алфавита; ")],1),_c('li',[_c(_vm.passwordValidator.lowercase && _vm.passwordValidator.$dirty
              ? 'OkRoundIcon'
              : 'ErrorRoundIcon',{tag:"component"}),_vm._v(" Строчные буквы латинского алфавита; ")],1),_c('li',[_c(_vm.passwordValidator.numbers && _vm.passwordValidator.$dirty
              ? 'OkRoundIcon'
              : 'ErrorRoundIcon',{tag:"component"}),_vm._v(" Цифры. ")],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }